import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

/*
 * Item displaying information for the report table
 */
export default function ReportItemADA({
  item,
  isOdd,
  type,
  allColumns = [],
  selectedColumns = [],
}) {
  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      <div
        className={styles.ibo}
        style={{
          fontWeight: type === "total" ? "bold" : "normal",
        }}
      >
        {item.IBO}
      </div>
      <div className={styles.lastName}>{item.lastName}</div>
      <div className={styles.displayName}>{item.displayName}</div>
      <div className={styles.pin}>{item.pin}</div>
      <div className={styles.diamond}>{item.diamond}</div>
      <div className={styles.attendingEvent}>{item.attendingEvent}</div>
      <div
        className={styles.adaName}
        style={{
          fontWeight: "bold",
        }}
      >
        {item.adaName}
      </div>
      <div className={styles.contact}>
        {item.contact?.split("|").map((part, index) => (
          <React.Fragment key={index}>
            {part.trim()}
            {index < item.contact.split("|").length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>

      {allColumns.map((col, index, arr) => {
        const colCount = arr.length;
        const colWidth = 30 / colCount;

        const match = item.columns.find((c) => c.columnName === col.columnName);

        const value =
          match && selectedColumns.includes(col.columnName)
            ? match.columnValue
            : "";

        return (
          <div
            key={`${col.columnName}-${value}-${index}`}
            className={index % 2 !== 0 ? styles.col : styles.oddCol}
            style={{ width: `${colWidth}%` }}
          >
            {value == 0 ? "" : value}
          </div>
        );
      })}
    </div>
  );
}

ReportItemADA.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
};
